<script>
	import { onMount } from 'svelte'
	import loadYouTubeApi from './loadYouTubeApi.js'
	import videos from './videos.js'
	import { fade } from 'svelte/transition'
	let noise
	let player;
	let videoId
	let ready = false
	
	let revealed = false

	let videoCount = 0
	
	const youtubeStates = {
		"-1": "unstarted",
		0: "ended",
		1: "playing",
		2: "paused",
		3: "buffering",
		5: "cued"	
	}
	let info=""
	
	let state = "unstarted"

	let currentSession = {
		videoCount: 0
	}

	let mixPanelWatchTimer

	$: {
		console.log("state", state)

		if(state == "ended") {
			next()
		}
	}
    loadYouTubeApi(() => {
		videoId = videos.pickRandom()
		mixpanel.track("Load Video", {videoId, count: currentSession.videoCount});
		currentSession.videoCount+=1;
		currentSession.startedAt = Date.now()
		
		player = new YT.Player('player', {
			height: window.innerWidth/1.777,
			width: window.innerWidth,
			videoId,
			playerVars : { 'controls' : 0, enablejsapi: 1, fs: 0, modestbranding: 1, playsinline: 1, rel: 0
			},
			events: {
				onReady() {
					ready = true

					const dur = player.getDuration()

					const minutes = Math.max(1, Math.round(dur/60))
					info = minutes + " minutes"

				},
				onStateChange(s) {
					state = youtubeStates[s.data]



					if(state == "buffering" || state == "playing") {
						const dur = player.getDuration()

						const minutes = Math.max(1, Math.floor(dur/60))
						info =  minutes + " minutes"
					}

				}
			}
		})

		window.player = player
	})

	
	const  rnd = () => Math.floor(Math.random()*100)
	
	onMount(() => {
		const timer = setInterval(() => {
			noise.style.backgroundPosition = `${rnd()}% ${rnd()}%`
		}, 30)
		
		return () => clearInterval(timer)
	})

	function play() {
		player.playVideo()

		

	}

	function reveal() {
		revealed = true
		const audioProgress = Math.floor( (Date.now()- currentSession.startedAt)/1000)

		mixpanel.track("Click Reveal", { videoId, time:audioProgress });

		// player.setPlaybackQuality('large')
		// 
	}

	function next() {
		ready = false
		player.stopVideo()
		revealed = false
		state = "unloaded"

		const audioProgress = Math.floor( (Date.now()- currentSession.startedAt)/1000)
		mixpanel.track("Click Next", { videoId, audioProgress });
		
		videoId = videos.pickRandom()
		player.loadVideoById( videoId )
		// player.setPlaybackQuality('small')
		
		currentSession.startedAt = Date.now()
		mixpanel.track("Load Video", {videoId, count: currentSession.videoCount});
		currentSession.videoCount+=1;
	}

	window.msg = (text)=> {
		mixpanel.track("Msg", { text });
	}
</script>

<div id="wrapper" class:revealed class:ready class={state}>
	<div id="player" ></div>
	<div id="noise" bind:this={noise}></div>

	<div id="playicon" on:click={play}></div>
	<div id="bufferingicon"></div>
	{#if !revealed }
	<button id="reveal" transition:fade on:click|preventDefault={reveal} >
		Reveal Artist
	</button>
	{/if}

	<button id="next" on:click|preventDefault={next}>
		Play Next Video
	</button>

	<div id="info">{info}</div>



</div>

<style>
	#wrapper {
		outline: 1px dotted gray;
		width: 100vw;
		height: 100vh;
		position: fixed;
		left: 0vw;
		top: 0vw;
		/* filter:  brightness(0.9); */
	}

	.revealed #player {
		
		filter: saturate(0.8) contrast(0.8) brightness(0.7) blur(0px);
		opacity: 1.0;

		transition: opacity 15s, filter 15s;

		/* display: block; */
	}

	
	#player {
		position: fixed;
		width: 100%;
		height: 100%;
		filter: saturate(0.1) contrast(0.5) brightness(0.7) blur(50px);
		opacity: 0.0;   
		transition: opacity 0s, filter 0s;		
		/* display: none; */
	}

	#noise {
		width: 100%;
		height: 100%;
		
		/* background-size: 500px 500px; */
		opacity: 0.2;

		position: fixed;
		top: 0;
		left: 0;
		pointer-events: none;
		transition: opacity 10s;
	}

	.revealed #noise {
		opacity: 0.0;
	}
	
	#playicon, #bufferingicon {
		position: fixed;
		width: 30vw;
		height: 30vw;
		background: transparent;
		background-size: 30vw;
		left: 35vw;
		top: calc(50vh - 15vw);
		opacity: 0.0;
		/* filter: invert(); */
		transition: opacity 0.5s;

	
	}

	#playicon {
	
		background-image: url('/playicon.png');
		cursor:pointer;
	}

	

	#bufferingicon {
	
		background-image: url('/bufferingicon2.png');
		pointer-events: none;
		animation: spin 5000ms infinite linear; 
		transition: opacity 1.5s;
		width: 20vw;
		height: 20vw;
		
		background-size: 20vw;
		left: 40vw;
		top: calc(50vh - 10vw);
	}


	.unstarted #bufferingicon {
		opacity: 0.2;
	}
	.ready #bufferingicon {
		opacity: 0;
	}
	.ready #playicon {
		opacity: 0.2;
	}

	.buffering #playicon {
		opacity: 0;
		
	}

	 .buffering #bufferingicon {
		opacity: 0.2;
		
	}


	.playing #playicon {
		opacity: 0.0;
		
	}

	#info {
		position: fixed;
		bottom: 14vh;

		width: 100vw;
		text-align: center;
		color: white;
		opacity: 0.2;
		font-weight: bold;
		pointer-events: none;
	}

	button {
		position: fixed;
		bottom: 10vh;
		
		padding: 3vh 4vw;
		background: transparent;
		border: 0;
		cursor: pointer;
		/* border: 3px dotted #555; */
		color: white;
		opacity: 0.2;
		font-size: 2vw;
		font-weight: bold;
		border-radius: 1vw;
		transition: all 1s;
		/* text-shadow: 0px 0px 3px rgba(255,255,255,0.4); */
	}
	
	button:hover {
		/* border-color: #fff; */
		/* color: #fff; */
		opacity: 1.0;
	}
	button#reveal {
		left: 10vh;
	}

	
	button#next {
		right: 10vh;
	}

	@keyframes pulse {
		0% { transform: scale(1); opacity: 0.2; }
		50% { transform: scale(1.0); opacity: 0.1; }
		100% { transform: scale(1.0); opacity: 0.2; }
	}

	@keyframes spin {
		from {
			transform:rotate(0deg);
		}
		to {
			transform:rotate(360deg);
		}
	}

	
</style>